/**
 * @file transferConstants.js
 * @description Constants for the Transfer module within the Dashboard section.
 *              Includes tab configurations and error messages.
 *
 * @module transferConstants
 *
 * @exports TRANSFER_TABS   - Tab label strings for the transfer panel.
 * @exports TRANSFERS_ERRORS - Error message strings for transfer data fetching.
 */
export const TRANSFER_TABS = {
    TEXTS: "Texts",
    EMAILS: "Emails",
};

export const TRANSFERS_ERRORS = {
    FETCH_TEXTS_ERROR: "Error fetching transfer texts.",
    FETCH_EMAILS_ERROR: "Error fetching transfer emails.",
};